


































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto'
import ActivityCategoryEdit from '@/components/Activities/ActivityCategoryEdit.vue';
import ActivityCategoryCreate from '@/components/Activities/ActivityCategoryCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'ActivityCategories',
  components: { ActivityCategoryEdit, ActivityCategoryCreate }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentActivityCategory(null);
    }

    async updateCurrentCategory(category: ActivityCategoryDto) {
        AgencySettingsModule.updateCurrentActivityCategory(category);
    }

    get currentCategory() {
        return AgencySettingsModule.currentActivityCategory;
    }

    get loading() {
        return AgencySettingsModule.loadingActivityCategories;
    }

    get activityCategories() {
        return AgencySettingsModule.activityCategories;
    }
}
